export function getQueryValue(key: string){
    const query = window.location.search.slice(1);
    const keys = {};
    query.split("&").map(node => {
        const [key, value] = node.split("=");
        keys[key] = value;
    });
    return keys[key];
}